import React from "react"
import { useStaticQuery, graphql } from "gatsby"


const Logos = ({ name }) => {
    const data = useStaticQuery(graphql`
        {
            fondLogo: file(relativePath: {eq: "project_logos/fondazione-logo.svg"}) {
                publicURL
            }
            almoLogo: file(relativePath: {eq: "project_logos/almonature-logo.svg"}) {
                publicURL
            }
            caflLogo: file(relativePath: {eq: "project_logos/cafl-logo.svg"}) {
                publicURL
            }
            hwLogo: file(relativePath: {eq: "project_logos/hw-logo.svg"}) {
                publicURL
            }
            rvfLogo: file(relativePath: {eq: "project_logos/rvf-logo.svg"}) {
                publicURL
            }
            bioLogo: file(relativePath: {eq: "project_logos/bio-logo.svg"}) {
                publicURL
            }
        }
    `)

    if (!['fondLogo', 'almoLogo', 'caflLogo', 'hwLogo', 'rvfLogo', 'bioLogo'].includes(name))
    {
        return false;
    } else {
        return <img src={data[name].publicURL} alt="Logo" />
    }
}

export default Logos